var _rect, _path, _path2, _path3, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20.2856,
    width: 38,
    height: 16.5714,
    rx: 4,
    stroke: "#008CFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.42861C11.4545 5.00003 14.8727 2.85718 19.8182 2.85718C24.7636 2.85718 28.4242 5.00003 30 6.42861",
    stroke: "#008CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2852 10.7144C15.1163 9.85725 17.0696 8.57153 19.8955 8.57153C22.7215 8.57153 24.8133 9.85725 25.7137 10.7144",
    stroke: "#008CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 14.2858C17.5582 14.0001 18.5348 13.5715 19.9478 13.5715C21.3608 13.5715 22.4066 14.0001 22.8569 14.2858",
    stroke: "#008CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27.1428,
    width: 16.4286,
    height: 2.14286,
    rx: 1.07143,
    fill: "#008CFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.57227,
    y: 27.1428,
    width: 2.14286,
    height: 2.14286,
    rx: 1.07143,
    fill: "#008CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouter);
export default __webpack_public_path__ + "static/media/Router.05c1c0fa625f0dc25153be1ac84af58a.svg";
export { ForwardRef as ReactComponent };